import React from 'react';
import { Box, Grid, Chip } from '@material-ui/core';
import { makeStyles, Theme } from '@material-ui/core/styles';

import { IOnboardingLane, IOnboardingFlowLaneMapper } from '../../../services/types';

const useStyles = makeStyles((theme: Theme) => ({
  link: {
    color: theme.palette.primary.main,
    display: 'inline-block',
    cursor: 'pointer',
    padding: '4px',
    '&:hover': {
      fontWeight: 'bold',
      color: theme.palette.primary.main,
      textDecoration: 'underline',
    },
  },
  popoverItemTitle: {
    flexGrow: 1,
  },
  popoverPriority: {
    fontSize: 14,
    color: theme.palette.primary.main,
  },
}));

export const LiveOnFlowsList = (props: { mappers?: IOnboardingFlowLaneMapper[] }): JSX.Element => {
  const classes = useStyles();
  return (
    <Grid container spacing={1}>
      {props.mappers?.map(flowItem => (
        <Grid item xs={12} key={`flow-itme-live-${flowItem.id}`}>
          <Grid container alignContent="stretch">
            <Chip
              size="small"
              label={flowItem.flow?.isActive ? 'Activated' : 'Deactivated'}
              color={flowItem.flow?.isActive ? 'primary' : 'default'}
              style={{ marginRight: 8, color: flowItem.flow?.isActive ? undefined : '#666666' }}
            />
            <div className={classes.popoverItemTitle}>
              <span className={classes.popoverPriority}>{flowItem.flowId}</span> {flowItem.flow?.title}
            </div>
          </Grid>
        </Grid>
      ))}
    </Grid>
  );
};

export const LiveOnFlows = (props: { lane: IOnboardingLane }): JSX.Element => {
  const mappers = (props.lane.flowLaneMappers || []).filter(mapper => mapper.flow?.isActive);
  return (
    <Box padding={2} width={400}>
      <Grid container spacing={1}>
        <Grid item xs={12}>
          This onboarding lane is live on
        </Grid>
        <Grid item xs={12}>
          <LiveOnFlowsList mappers={mappers} />
        </Grid>
      </Grid>
    </Box>
  );
};
